export default __webpack_public_path__ + "static/award-00474eee5bb75ddab134b8a8445622d9.svg";